<template>
    <v-dialog :dialog="dialog" max-width="600px" transition="dialog-top-transition">
      <v-card>
        <v-card-title  class="d-flex justify-space-between align-center">{{ isEdit ? "Edit " : "Add New " }}{{title}}
          <v-icon v-if="isTag" icon size="50" :color="data.color">mdi-{{ data.icon }}</v-icon>
          <v-chip v-if="isMessageTemplate" icon size="50" :color="data.color"><span style="margin: 8px;">{{ data.name }}</span></v-chip>
          <v-icon size="20" color="red"  @click="closeDialog">mdi-close</v-icon>
        </v-card-title>
        <v-card-text>
          <v-form ref="form" v-model="valid">

            <v-text-field v-model="data.name" :label="title+' Name'" variant="outlined" ref="nameField"
                :disabled="(isTag)?!isTagEditable:false"
                validate-on="input"
                :rules="nameRules"
                maxlength="20"
                counter
                density="compact"
            ></v-text-field>
              <v-select
                v-if="(isTag || isType )&& (data.tag_source ==='convoTags'||isConversation)"
                :disabled="(isTag)?!isTagEditable:false"
                class="mt-3 mb-3"
                label="Select a Process"
                validate-on="input"
                :rules="ProcessRules"
                v-model="data.Process"
                :items="allProcess"
                item-title="type_name"
                item-value="type_name"
                variant="outlined"
                density="compact"
              />
                     <v-select
                v-if="(isTag && isSettings) ||isTag && isType"
                :disabled="(isTag)?!isTagEditable:false"
                class="mt-3 mb-3"
                label="Select a tag source"
                v-model="data.tag_source"
                :items="tagSourceOptions"
                :return-object="false"
                variant="outlined"
                density="compact"
              />
            <v-text-field
              v-if="isTag || isType"
              v-model="data.description"
              variant="outlined"
              label="Description"
              density="compact"
              :rules="isTag ? [v => !!v || 'Description is required'] : []"
              validate-on="input"
              @input="onDescriptionInput"
            ></v-text-field>

            <v-combobox v-if="isMessageTemplate"
                v-model="data.contact_type_id"
                :items="_contact_Types"
                item-value="type_id"
                item-title="type_name"
                item-key="type_id"
                label="Select Contact Type"
                variant="outlined"
                :return-object="false"
                validate-on="input"
                density="compact"
            >
                <template v-slot:item="{ item, props }">
                  <v-list-item v-bind="props" @click="checkTemplateTitle">
                    <template #prepend>
                      <v-avatar
                        rounded="lg"
                        size="x-small"
                        :color="item.raw.color"
                      >
                        <v-icon size="x-small">mdi-account-outline</v-icon>
                      </v-avatar>
                    </template>
                  </v-list-item>
                </template>
            </v-combobox>
          <!-- Placeholder suggestions popup  -->
  <RecycleScroller
    v-if="showPlaceholderPopup"
    class=""
    :items="filteredPlaceholders"
    :item-size="48" 
    key-field="id" 
  >
    <template #default="{ item, index }">
      <v-list-item
        :key="index"
        @click="insertPlaceholder(item)"
      >
        <v-list-item-title>{{ item }}</v-list-item-title>
      </v-list-item>
    </template>
  </RecycleScroller>

            <v-textarea v-if="isMessageTemplate"
              v-model="data.template"
              ref="templateTextarea"
              @keyup="checkPlaceholderTrigger"
              label="Write your template. Use $ to replace name's and value's"
              row-height="15"
              rows="1"
              variant="outlined"
              auto-grow
              :rules="RULES.REQUIRED_FIELD('Template')"
            ></v-textarea>

            <div v-if="isTag && (suggestIconsLoading || aiSuggestedIcons.length)">
              <div class="text-caption mb-1 mt-2 d-flex align-center" style="color: #757575;">
                Suggested
                <v-progress-circular v-if="suggestIconsLoading" indeterminate size="14" width="2" class="ml-2" />
              </div>
              <div v-for="(name, index) in aiSuggestedIcons" :key="'s-' + index" style="display: inline;">
                <v-btn icon style="margin-left: 1%; display: inline"
                  :style="name === data.icon ? 'outline: 2px solid currentColor; border-radius: 50%;' : ''"
                  @click="data.icon = name">
                  <v-icon icon small :color="data.color">mdi-{{ name }}</v-icon>
                </v-btn>
              </div>
              <v-divider class="mt-2 mb-1" />
            </div>

            <div v-if="isTag && ((data.tag_source === 'contactTags') || isFrontdesk) && !suggestIconsLoading && !aiSuggestedIcons.length">
              <div v-for="(name, index) in tagIcons" :key="index" style="display: inline;">
                <v-btn :disabled="!isDuplicateicon(name) || !isTagEditable" icon style="margin-left: 1%; display: inline" 
                  @click="data.icon = name"
                  >
                  <v-icon icon small :color="data.color">mdi-{{ name }}</v-icon>
                </v-btn>
              </div>
            </div>
            <div v-if="isTag && ((data.tag_source === 'convoTags') || isConversation) && !suggestIconsLoading && !aiSuggestedIcons.length">
              <div v-for="(name, index) in convotagIcons" :key="index" style="display: inline;">
                <v-btn :disabled="!isDuplicateicon(name) || !isTagEditable" icon style="margin-left: 1%; display: inline"
                  @click="data.icon = name"
                  >
                  <v-icon icon small :color="data.color">mdi-{{ name }}</v-icon>
                </v-btn>
              </div>
            </div>
            <div v-if="isTag && data.tag_source === 'osclaimsTags' && !suggestIconsLoading && !aiSuggestedIcons.length">
              <div v-for="(name, index) in osclaimsTagIcons" :key="index" style="display: inline;">
                <v-btn :disabled="!isDuplicateicon(name) || !isTagEditable" icon style="margin-left: 1%; display: inline"
                  @click="data.icon = name"
                  >
                  <v-icon icon small :color="data.color">mdi-{{ name }}</v-icon>
                </v-btn>
              </div>
            </div>
            <div v-if="isTag && data.tag_source === 'OSclaimsconvoTags' && !suggestIconsLoading && !aiSuggestedIcons.length">
              <div v-for="(name, index) in osclaimsConvoTagIcons" :key="index" style="display: inline;">
                <v-btn :disabled="!isDuplicateicon(name) || !isTagEditable" icon style="margin-left: 1%; display: inline"
                  @click="data.icon = name"
                  >
                  <v-icon icon small :color="data.color">mdi-{{ name }}</v-icon>
                </v-btn>
              </div>
            </div>
            <v-container fluid>
              <v-row justify="center">
                <v-col cols="12" md="6" class="d-flex justify-center">
                  <v-color-picker  v-model="data.color" :swatches="swatches" class="ma-2" show-swatches hide-mode-switch hide-inputs
                    dot-size="15" swatches-max-height="75" width="400" canvas-height="80"></v-color-picker>
                </v-col>
              </v-row>
            </v-container>
            <v-container fluid v-if="!isMessageTemplate">
              <v-row>
                <v-col class="d-flex align-center justify-start">
                  <v-switch v-model="data.switch1" :label="(isType) ? 'Can Be Set' : 'Enable Auto'" color="success"></v-switch>
                </v-col>
  
                <v-col class="d-flex align-center justify-start">
                  <v-switch v-model="data.switch2" :label="(isType) ? 'Can Be Change' : 'Block Further Usage'" :color="(isType) ? 'success':'red'"></v-switch>
                </v-col>
  
              </v-row>
            </v-container>
          </v-form>
        </v-card-text>
        <v-card-actions> 
          <v-icon v-if="isEdit && isTag && isTagEditable" size="30" color="red" @click="handleDeleteTag " elevation="2" style="margin-left: 5%;">mdi-delete</v-icon>
          <v-spacer></v-spacer>
          <v-btn color="green" @click="handleClick" :disabled="!valid">{{
            isEdit ? "Update" : "Create" }}</v-btn>
          <v-btn color="red darken-1" text @click="closeDialog">Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </template>
  
  
  <script>

  import TagService from '@/services/tagService';
  import { mapActions,mapGetters } from "vuex";
  import EventBus from "@/eventBus";
  import {ALERT} from "../../constants/alert.js"
  import {RULES} from "../../constants/validationRules.js"
  import MiscService from "../../services/miscService.js"
  export default {
    name : 'FrontDeskForm',
    data() {
      return {
        data:{
        id : null,
        name: "",
        description: "",
        icon : "",
        color: "",
        switch1: false,
        switch2: false,
        contact_type_id : 0, // for message templates
        template : '',
        },
        isTagEditable : true,
        originalName : "", // for name validation
        swatches: [
          ['#FF0000', '#F95454', '#EC8305'],
          ['#F3C623', '#A900FF', '#FB00FF'],
          ['#FF5E00', '#06B994', '#3B1E54'],
          ['#00FF9C', '#08C2FF', '#BF2EF0'],
          ['#0000FF', '#0000AA', '#B17457'],
        ],
        valid: true,
      allProcess: [],
      tag_source: null,
      Process: null,
      tagSourceOptions:["contactTags","convoTags","osclaimsTags","OSclaimsconvoTags"],
        tagIcons: [
          "tag",
          "creation-outline",
          "face-agent",
          "account-check",
          "tooth",
          "exclamation-thick",
          "hospital-building",
          "close",
          "account-alert",
          "apple"
        ],
        convotagIcons: [
          "file-account-outline",
          "file-account",
          "file-check-outline",
          "file-chart-check-outline",
          "file-edit-outline",
          "file-multiple-outline",
          "file-outline",
          "file-check-outline",
          "file-document-arrow-right-outline"
        ],
        osclaimsTagIcons: [
          "phone-outline",
          "file-document-edit-outline",
          "close-circle-outline",
          "check-circle-outline",
          "clock-outline",
          "gavel",
          "file-question-outline",
          "account-outline",
          "shield-outline",
          "refresh",
          "currency-usd",
          "archive-outline",
        ],
        osclaimsConvoTagIcons: [
          "chat-processing-outline",
          "comment-check-outline",
          "comment-alert-outline",
          "comment-question-outline",
          "comment-remove-outline",
          "forum-outline",
          "message-reply-text-outline",
          "phone-check",
          "timer-outline",
          "flag-outline",
          "bookmark-outline",
          "label-outline",
        ],
        _contact_Types : [],
        RULES,
        placeholderOptions: ["userName", "contactName", "ApptDateWithTime", "ApptLocation", "TodayDayOfWeek"],
        showPlaceholderPopup: false,
        currPlaceholderStart: null,
        typedPlaceholder: "",
        aiSuggestedIcons: [],
        suggestIconsLoading: false,
        _debounceTimer: null,
      };
    },
    props: {
      dialog: {type : Boolean,default : false},
      contactType: {type : Object,default : null},
      incoming_Tag: {type : Object,default : null},
      isEdit: {type : Boolean,default : false},
      isType: {type : Boolean,default : false}, // is contactType
      isTag : {type : Boolean, default : false},
      isMessageTemplate : {type : Boolean, default : false},
      messageTemplate : {type : Object, default : null},
      tagSource: { type: String, default: null },
    },
    watch: {
      'data.tag_source'(val) {
        if (val) this.onDescriptionInput();
      },
    },
    computed:{
      ...mapGetters("tags",["tags","allTags"]),
      ...mapGetters("people",["contactTypes"]),
      ...mapGetters("frontdesk",["message_templates"]),
      isFrontdesk() {  return ['/frontdesk', '/labCases'].includes(this.$route.path);},
    isConversation() { return this.$route.path === '/conversation'; },
    isSettings(){ return this.$route.path ==='/settings'},
    isOsClaims() { return this.$route.path === '/osclaims'; },
      title(){
        if(this.isType){
          return "Contact Type"
        }else if(this.isTag){
          return "Tag"
        }else if(this.isMessageTemplate){
          return "Message Template"
        }
      },
      nameRules() {
        return [
          v => !!v || 'Name is required',
          v => this.isEdit ? !this.isDuplicateNameForEdit(v) || 'This name is already in use' : !this.isDuplicateName(v) || 'This name is already in use'
        ];
      },
      ProcessRules(){
        return [
          v => !!v || 'process is required',
        ];
      },
        filteredPlaceholders() {
    if (!this.typedPlaceholder) return this.placeholderOptions;
    return this.placeholderOptions.filter(ph =>
      ph.toLowerCase().startsWith(this.typedPlaceholder.toLowerCase())
    );
  },
    },
    methods: {
      ...mapActions("people",["createContactType","updateContactType"]),
      ...mapActions("frontdesk",["createMessageTemplate","updateMessageTemplate"]),
      ...mapActions('tags', ["createTag", "updateTag", "deleteTag"]),
 checkPlaceholderTrigger(event) {
    const textareaEl = this.$refs.templateTextarea.$el.querySelector('textarea');
    const cursorIndex = textareaEl.selectionStart;
    const textBeforeCursor = this.data.template.slice(0, cursorIndex);

    const dollarIndex = textBeforeCursor.lastIndexOf('$');

    if (dollarIndex !== -1) {
      this.showPlaceholderPopup = true;
      this.currPlaceholderStart = dollarIndex;
      this.typedPlaceholder = textBeforeCursor.slice(dollarIndex + 1, cursorIndex);

      const rect = textareaEl.getBoundingClientRect();
      this.placeholderTop = rect.top + window.scrollY + 25; // 25px below textarea
      this.placeholderLeft = rect.left + window.scrollX + 5; // small left offset
    } else {
      this.showPlaceholderPopup = false;
      this.typedPlaceholder = "";
    }
  },
  insertPlaceholder(placeholder) {
    const textareaEl = this.$refs.templateTextarea.$el.querySelector('textarea');
    const start = this.currPlaceholderStart;
    const end = textareaEl.selectionStart;

    this.data.template =
      this.data.template.slice(0, start) +
      `$${placeholder}` +
      this.data.template.slice(end);

    this.showPlaceholderPopup = false;

    this.$nextTick(() => {
      textareaEl.selectionStart = textareaEl.selectionEnd = start + placeholder.length + 1;
      textareaEl.focus();
    });
  },

      onDescriptionInput() {
        clearTimeout(this._debounceTimer);
        const desc = (this.data.description || "").trim();
        if (!desc) {
          this.aiSuggestedIcons = [];
          this.suggestIconsLoading = false;
          return;
        }
        this.suggestIconsLoading = true;
        this._debounceTimer = setTimeout(async () => {
          try {
            const res = await TagService.suggestIcons(desc, this.data.tag_source);
            this.aiSuggestedIcons = (res.data.icons || []).filter(name =>
              this.isDuplicateicon(name) || (this.isEdit && this.isTag && name === this.data.icon)
            );
          } catch (err) {
            console.error("Icon suggestion failed:", err);
            this.aiSuggestedIcons = [];
          } finally {
            this.suggestIconsLoading = false;
          }
        }, 600);
      },
      isDuplicateName(name) {
        if(this.isType){
          return  this._contact_Types.find((type)=> type.type_name.toLowerCase() === name.toLowerCase().trim());
        }else if(this.isTag){
          return  this.allTags.find((tag)=> tag.tag_name.toLowerCase() === name.toLowerCase().trim());
        }else if(this.isMessageTemplate){
          return this.message_templates.find((template)=> template.title.toLowerCase() === name.toLowerCase().trim() && template.contact_type_id == this.data.contact_type_id);
        }
      },
      isDuplicateNameForEdit(name) {
        if(this.isType){
          return name?.toLowerCase().trim() !== this.originalName?.toLowerCase().trim() && 
          this._contact_Types.find((type)=> type.type_name.toLowerCase() === name.toLowerCase().trim());
        }else if(this.isTag){
          return name?.toLowerCase().trim() !== this.originalName?.toLowerCase().trim() && 
          this.allTags.find((tag)=> tag.tag_name.toLowerCase() === name.toLowerCase().trim());
        }else if(this.isMessageTemplate){
          return this.message_templates.find((template)=> template.title.toLowerCase().trim() === name.toLowerCase().trim() && template.contact_type_id == this.data.contact_type_id && template.template_id != this.data.id); 
        }
      },

      isDuplicateicon(name) {
        if(this.allTags.length)
            return  !this.allTags.find((tag)=> tag.tag_icon.toLowerCase() === name.toLowerCase());
        else
          return true;
      },
      handleClick() {
      if (this.isType) {
        this.handleSaveContactType();
      }else if(this.isTag) {
        this.handleSaveTag();
      }else if(this.isMessageTemplate) {
        this.handleSaveMessageTemplate();
      }
    },
      async handleSaveContactType() {
        let contact_Type ={ 
          type_name: this.data.name,
          type_desc: this.data.description,
          color: this.data.color,
          can_be_set: this.data.switch1,
          can_be_changed: this.data.switch2,
        }
        if (!this.isEdit) {
          // Create new contact type
          await this.createContactType(contact_Type);

        }else{
          //edit contact type
          this.updateContactType({"contact_Type" : contact_Type, "id" :this.data.id});
        }
        this.closeDialog();
      },
      closeDialog() {
        this.$emit('close');
      },
  
      async handleDeleteTag () {
        
        if (this.isEdit) {
          const userConfirm = confirm("Do you want to Delete this Tag ?");
          if (userConfirm) {
            try {
              await this.deleteTag(this.data.id);
              this.closeDialog();
            } catch (error) {
              console.error(error);
            }
          }
  
        }
      },
      async handleSaveTag() {
        if(!this.data.icon){
          EventBus.$emit("alert", {
            message: "Icon Not Selected",
            type: ALERT.WARNING
          });
          return;
        }
  if (this.isFrontdesk) {
    this.data.tag_source = 'contactTags';
  } else if (this.isConversation) {
    this.data.tag_source = 'convoTags';
  } else if (this.isOsClaims) {
    this.data.tag_source = this.data.tag_source || 'osclaimsTags';
  }
         const tag = {
    tag_name: this.data.name,
    tag_icon: this.data.icon,
    tag_desc: this.data.description,
    tag_Process: this.data.Process ? this.data.Process : (this.data.Process?.type_name ? this.data.Process.type_name : "null"),
    tag_source: this.data.tag_source || null, 
    tag_color: this.data.color,
    enable_auto: !!this.data.switch1,
    unlist: !!this.data.switch2
  };
        if (!this.isEdit) {
          // Creating new Tag
          try {
            await this.createTag(tag);
            this.$emit("close");
          } catch (error) {
            console.error(error);
          }
        } else {
          //Edit Tag
          try {
            await this.updateTag({tag_data:tag,tag_id:this.data.id});
            this.$emit("close");
          } catch (error) {
            console.error(error);
          }
        }
      },
      checkTemplateTitle(){
        this.$refs.nameField?.validate();
      },
      async handleSaveMessageTemplate(){
        let payload = {
            "title": this.data.name, 
            "template" : this.data.template,
            "contact_type_id" : this.data.contact_type_id == 0 ? null : this.data.contact_type_id,
            "color" : this.data.color,
            "is_active" : true,
        }
        if(this.isEdit && this.isMessageTemplate) {
          await this.updateMessageTemplate({"data": payload, "template_id": this.data.id});
        }else {
          await this.createMessageTemplate(payload);
        }
        this.$emit("close");
      }
    },
    async created() {
      const res = await MiscService.getProcess();
      let process = res?.data || [];
      process.unshift({
        client_id: null,
        id: "0",
        type_name: "All"
      });
      this.allProcess = process;
      if (this.isTag && !this.isEdit && this.tagSource) {
        this.data.tag_source = this.tagSource;
      }
      if(this.isType & this.isEdit){
        this.data.id = this.contactType.type_id;
        this.data.name = this.contactType.type_name;
        this.originalName =  this.contactType.type_name;
        this.data.description = this.contactType.type_desc;
        this.data.color = this.contactType.color;
        this.data.switch1 = this.contactType.can_be_set;
        this.data.switch2 = this.contactType.can_be_changed;
      }else if(this.isTag & this.isEdit){
        this.data.id = this.incoming_Tag.tag_id;
        this.data.name = this.incoming_Tag.tag_name;
        this.data.description = this.incoming_Tag.tag_desc;
        this.data.Process = this.incoming_Tag.tag_Process || null;
        this.originalName =  this.incoming_Tag.tag_name;
        this.data.icon = this.incoming_Tag.tag_icon;
        this.data.color = this.incoming_Tag.tag_color;
        this.data.switch1 = this.incoming_Tag.enable_auto;
        this.data.switch2 = this.incoming_Tag.unlist;
        this.data.tag_source = this.incoming_Tag.tag_source;
        if (this.data.description) this.onDescriptionInput();

        try {
          if(this.incoming_Tag.is_editable){ // if tag is editable check again in data base 
              // if tag is associated with any contact or conversation and default tag are not allowed to edit name and icon.
              let res = await TagService.isTagEditable(this.incoming_Tag.tag_id)
              console.log("Can Edit Tag"+res.data);
              this.isTagEditable = res.data;
          }else{
            this.isTagEditable = false;
          }
        } catch (error) {
          console.log(error);
        }

      }else if(this.isMessageTemplate & this.isEdit){
        this.data.id = this.messageTemplate.template_id;
        this.data.name = this.messageTemplate.title;
        this.originalName = this.messageTemplate.title;
        this.data.color = this.messageTemplate.color;
        this.data.contact_type_id = this.messageTemplate.contact_type_id;
        this.data.template = this.messageTemplate.template;
        
      }
      if(this.isMessageTemplate){
        if(this.isMessageTemplate){
        this._contact_Types = [...this.contactTypes];
        this._contact_Types.push({ type_id : 0, type_name: 'All'});
      }
    }
    },
  };
  </script>
  
  <style>
.placeholder-popup {
  max-height: 150px;
  overflow-y: auto;
  border: 5px solid #000000;
  background: rgb(255, 255, 255);
  width: 200px;
  position: absolute;
  z-index: 100;
  top: 0px;  
  left: 0px; 
}


</style>